// Imports => React
import React, {memo, useMemo} from 'react';
import {Props} from './ac-loader.proptypes';
import clsx from 'clsx';

// Imports => Constants
import VISUALS from '@asdf-constants/visuals.constants';
// import Loader from '@asdf-assets/images/brand-1x.svg';

// Imports => Utilities
import {AcGenerateThemeClassNames} from '@asdf-utils';

const _CLASSES = {
  MAIN: 'ac-loader',
  WRP: {
    MAIN: 'ac-loader-wrp',
    COVER: 'ac-loader-wrp--cover',
    INLINE: 'ac-loader-wrp--inline',
    TRANSPARENT: 'ac-loader-wrp--transparent',
    PITCH: 'ac-loader-wrp--pitch',
    LOADING: 'ac-loader-wrp--loading',
  },
  THEME: AcGenerateThemeClassNames('ac-loader'),
  VISUAL: 'ac-loader__visual',
};

// Component
const AcLoader = memo(
  ({
    Visual = VISUALS.LOADER,
    theme = 'omega',
    loading = false,
    cover = false,
    inline = false,
    pitch = false,
    transparent = false,
    wrpClassName,
    className,
  }) => {
    const getLoaderVisualClassNames = useMemo(() => {
      return clsx(_CLASSES.VISUAL);
    }, []);

    const getLoaderClassNames = useMemo(() => {
      return clsx(_CLASSES.MAIN, className && className);
    }, [className]);

    const getLoaderWrpClassNames = useMemo(() => {
      return clsx(
        _CLASSES.WRP.MAIN,
        loading && _CLASSES.WRP.LOADING,
        cover && _CLASSES.WRP.COVER,
        inline && _CLASSES.WRP.INLINE,
        transparent && _CLASSES.WRP.TRANSPARENT,
        pitch && _CLASSES.WRP.PITCH,
        theme && _CLASSES.THEME[theme.toUpperCase()],
        wrpClassName
      );
    }, [loading, cover, inline, transparent, theme, pitch, wrpClassName]);

    return (
      <div className={getLoaderWrpClassNames}>
        <div className={getLoaderClassNames}>
          <div className={getLoaderVisualClassNames}>
            <Visual alt={'loader-visual'} />
          </div>
        </div>
      </div>
    );
  }
);

AcLoader.displayName = 'AcLoader';
AcLoader.propTypes = Props;

export {AcLoader};
export default AcLoader;
